/* =========================================================
   PRODUCT CARD QUICK ADD
   Desktop + Mobile Bottom Sheet
   ========================================================= */

class ProductCardQuickAdd {

  constructor() {

    this.activeQuickAdd = null;

    this.init();

  }


  /* =======================================================
     INITIALIZE
     ======================================================= */

  init() {

    /*
     * Automatically select first available size.
     */
    this.initializeDefaultSizes();


    /*
     * Create mobile backdrop.
     */
    this.createMobileBackdrop();


    /*
     * Add mobile trigger events.
     */
    this.initializeMobileTriggers();


    /*
     * Global click handling.
     */
    document.addEventListener(
      'click',
      (event) => {


        /* -----------------------------------------------
           SIZE BUTTON
           ----------------------------------------------- */

        const sizeButton =
          event.target.closest(
            '[data-quick-add-size]'
          );


        if (sizeButton) {

          this.selectSize(sizeButton);

          return;

        }


        /* -----------------------------------------------
           ADD TO CART
           ----------------------------------------------- */

        const addButton =
          event.target.closest(
            '[data-quick-add-submit]'
          );


        if (addButton) {

          event.preventDefault();

          this.addToCart(addButton);

          return;

        }


        /* -----------------------------------------------
           CLOSE BUTTON
           ----------------------------------------------- */

        const closeButton =
          event.target.closest(
            '[data-quick-add-close]'
          );


        if (closeButton) {

          this.closeMobileSheet();

        }

      }
    );


    /*
     * Escape key closes mobile sheet.
     */
    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key === 'Escape'
        ) {

          this.closeMobileSheet();

        }

      }
    );

  }


  /* =======================================================
     DEFAULT SIZE
     ======================================================= */

  initializeDefaultSizes() {

    document
      .querySelectorAll(
        '[data-quick-add]'
      )
      .forEach(
        (quickAdd) => {

          const defaultSize =
            quickAdd.querySelector(
              '[data-default-selected="true"]'
            );


          if (!defaultSize) {

            return;

          }


          /*
           * Store selected variant.
           */
          quickAdd.dataset.selectedVariant =
            defaultSize.dataset.variantId;


          /*
           * Selected visual state.
           */
          defaultSize.classList.add(
            'is-selected'
          );


          defaultSize.setAttribute(
            'aria-pressed',
            'true'
          );


          /*
           * Enable Add To Cart.
           */
          const addButton =
            quickAdd.querySelector(
              '[data-quick-add-submit]'
            );


          if (addButton) {

            addButton.disabled = false;

          }

        }
      );

  }


  /* =======================================================
     CREATE MOBILE BACKDROP
     ======================================================= */

  createMobileBackdrop() {

    if (
      document.querySelector(
        '[data-quick-add-backdrop]'
      )
    ) {

      return;

    }


    const backdrop =
      document.createElement('div');


    backdrop.className =
      'quick-add-mobile-backdrop';


    backdrop.setAttribute(
      'data-quick-add-backdrop',
      ''
    );


    backdrop.addEventListener(
      'click',
      () => {

        this.closeMobileSheet();

      }
    );


    document.body.appendChild(
      backdrop
    );


    this.mobileBackdrop =
      backdrop;

  }


  /* =======================================================
     MOBILE TRIGGERS
     ======================================================= */

  initializeMobileTriggers() {

    document.addEventListener(
      'click',
      (event) => {

        const trigger =
          event.target.closest(
            '[data-mobile-quick-add-trigger]'
          );


        if (!trigger) {

          return;

        }


        event.preventDefault();

        event.stopPropagation();


        const quickAdd =
          trigger.closest(
            '.card-wrapper'
          )?.querySelector(
            '[data-quick-add]'
          );


        if (!quickAdd) {

          return;

        }


        this.openMobileSheet(
          quickAdd
        );

      }
    );

  }


  /* =======================================================
     OPEN MOBILE SHEET
     ======================================================= */

  openMobileSheet(
    quickAdd
  ) {

    /*
     * Only use bottom sheet on mobile.
     */
    if (
      window.innerWidth >= 750
    ) {

      return;

    }


    /*
     * Close previously open sheet.
     */
    if (
      this.activeQuickAdd &&
      this.activeQuickAdd !== quickAdd
    ) {

      this.closeMobileSheet();

    }


    /*
     * Store active card.
     */
    this.activeQuickAdd =
      quickAdd;


    /*
     * Add open class.
     */
    quickAdd.classList.add(
      'is-mobile-open'
    );


    /*
     * Show backdrop.
     */
    if (
      this.mobileBackdrop
    ) {

      this.mobileBackdrop.classList.add(
        'is-visible'
      );

    }


    /*
     * Lock body scrolling.
     */
    document.body.classList.add(
      'quick-add-sheet-open'
    );


    /*
     * Accessibility.
     */
    quickAdd.setAttribute(
      'aria-hidden',
      'false'
    );

  }


  /* =======================================================
     CLOSE MOBILE SHEET
     ======================================================= */

  closeMobileSheet() {

    if (
      !this.activeQuickAdd
    ) {

      return;

    }


    this.activeQuickAdd.classList.remove(
      'is-mobile-open'
    );


    if (
      this.mobileBackdrop
    ) {

      this.mobileBackdrop.classList.remove(
        'is-visible'
      );

    }


    document.body.classList.remove(
      'quick-add-sheet-open'
    );


    this.activeQuickAdd.setAttribute(
      'aria-hidden',
      'true'
    );


    this.activeQuickAdd =
      null;

  }


  /* =======================================================
     SELECT SIZE
     ======================================================= */

  selectSize(button) {

    const quickAdd =
      button.closest(
        '[data-quick-add]'
      );


    if (!quickAdd) {

      return;

    }


    /*
     * Remove old selection.
     */
    quickAdd
      .querySelectorAll(
        '[data-quick-add-size]'
      )
      .forEach(
        (sizeButton) => {

          sizeButton.classList.remove(
            'is-selected'
          );


          sizeButton.setAttribute(
            'aria-pressed',
            'false'
          );

        }
      );


    /*
     * Select clicked size.
     */
    button.classList.add(
      'is-selected'
    );


    button.setAttribute(
      'aria-pressed',
      'true'
    );


    /*
     * Store variant.
     */
    quickAdd.dataset.selectedVariant =
      button.dataset.variantId;


    /*
     * Enable Add To Cart.
     */
    const addButton =
      quickAdd.querySelector(
        '[data-quick-add-submit]'
      );


    if (addButton) {

      addButton.disabled = false;

    }

  }


  /* =======================================================
     ADD TO CART
     ======================================================= */

  async addToCart(button) {

    const quickAdd =
      button.closest(
        '[data-quick-add]'
      );


    if (!quickAdd) {

      return;

    }


    const variantId =
      quickAdd.dataset.selectedVariant;


    if (!variantId) {

      return;

    }


    /*
     * Prevent double click.
     */
    if (
      button.classList.contains(
        'is-loading'
      )
    ) {

      return;

    }


    const label =
      button.querySelector(
        '[data-quick-add-label]'
      );


    /*
     * Loading.
     */
    button.disabled = true;

    button.classList.add(
      'is-loading'
    );


    if (label) {

      label.textContent =
        'Adding...';

    }


    try {

      /*
       * Shopify AJAX API
       * Request updated cart sections.
       */
      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {

            method: 'POST',

            headers: {

              'Content-Type':
                'application/json',

              Accept:
                'application/json'

            },

            body: JSON.stringify({

              items: [

                {

                  id:
                    Number(variantId),

                  quantity: 1

                }

              ],


              /*
               * Request fresh sections.
               */
              sections: [

                'cart-drawer',

                'cart-icon-bubble'

              ],


              sections_url:
                window.location.pathname

            })

          }
        );


      const data =
        await response.json();


      /*
       * Shopify error.
       */
      if (!response.ok) {

        throw new Error(
          data.description ||
          'Unable to add product to cart.'
        );

      }


      /*
       * Update cart UI.
       */
      await this.updateCart(
        data
      );


      /*
       * Success.
       */
      button.classList.remove(
        'is-loading'
      );


      if (label) {

        label.textContent =
          'Added';

      }


      /*
       * Close mobile sheet after
       * successful add.
       */
      if (
        window.innerWidth < 750
      ) {

        setTimeout(
          () => {

            this.closeMobileSheet();

          },
          350
        );

      }


      /*
       * Reset button.
       */
      setTimeout(
        () => {

          if (label) {

            label.textContent =
              'Add to cart';

          }


          button.disabled =
            false;

        },
        900
      );

    }


    catch (error) {

      console.error(
        'Product Quick Add Error:',
        error
      );


      button.classList.remove(
        'is-loading'
      );


      if (label) {

        label.textContent =
          'Try again';

      }


      setTimeout(
        () => {

          if (label) {

            label.textContent =
              'Add to cart';

          }


          button.disabled =
            false;

        },
        1500
      );

    }

  }


  /* =======================================================
     UPDATE CART
     FULL CART DRAWER REPLACEMENT
     ======================================================= */

  async updateCart(data) {

    /*
     * Safety check.
     */
    if (
      !data ||
      !data.sections
    ) {

      console.error(
        'Quick Add: Cart sections were not returned.',
        data
      );

      return;

    }


    /* =====================================================
       UPDATE CART ICON BUBBLE
       ===================================================== */

    const cartBubbleHTML =
      data.sections[
        'cart-icon-bubble'
      ];


    if (cartBubbleHTML) {

      const bubbleContainer =
        document.createElement(
          'div'
        );


      bubbleContainer.innerHTML =
        cartBubbleHTML;


      const newCartBubble =
        bubbleContainer.querySelector(
          '#cart-icon-bubble'
        );


      const oldCartBubble =
        document.querySelector(
          '#cart-icon-bubble'
        );


      if (
        newCartBubble &&
        oldCartBubble
      ) {

        oldCartBubble.replaceWith(
          newCartBubble
        );

      }

    }


    /* =====================================================
       GET FRESH CART DRAWER HTML
       ===================================================== */

    const cartDrawerHTML =
      data.sections[
        'cart-drawer'
      ];


    if (!cartDrawerHTML) {

      console.error(
        'Quick Add: cart-drawer section is missing.'
      );

      return;

    }


    /*
     * Create temporary container
     * for Shopify returned HTML.
     */
    const container =
      document.createElement(
        'div'
      );


    container.innerHTML =
      cartDrawerHTML;


    /*
     * Find the new complete cart drawer.
     */
    const newCartDrawer =
      container.querySelector(
        'cart-drawer'
      );


    /*
     * Find the existing cart drawer.
     */
    const oldCartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      !newCartDrawer ||
      !oldCartDrawer
    ) {

      console.error(
        'Quick Add: Unable to find cart drawer.'
      );

      return;

    }


    /* =====================================================
       PRESERVE OPEN STATE
       ===================================================== */

    /*
     * Add active class before replacing.
     */
    newCartDrawer.classList.add(
      'active'
    );


    /*
     * Replace the ENTIRE cart drawer.
     *
     * This is important when:
     *
     * Empty Cart
     *      ↓
     * First Product Added
     *      ↓
     * Populated Cart
     */
    oldCartDrawer.replaceWith(
      newCartDrawer
    );


    /*
     * Wait until new DOM is available.
     */
    await new Promise(
      (resolve) => {

        requestAnimationFrame(
          () => {

            requestAnimationFrame(
              () => {

                resolve();

              }
            );

          }
        );

      }
    );


    /*
     * Find newly inserted cart drawer.
     */
    const updatedCartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    /*
     * Open using Dawn's native method.
     */
    if (
      updatedCartDrawer &&
      typeof updatedCartDrawer.open ===
        'function'
    ) {

      /*
       * Remove temporary active class
       * and let Dawn handle opening.
       */
      updatedCartDrawer.classList.remove(
        'active'
      );


      updatedCartDrawer.open();

    }


    /*
     * Fallback if open() is unavailable.
     */
    else if (updatedCartDrawer) {

      updatedCartDrawer.classList.add(
        'active'
      );

    }

  }


  /* =======================================================
     REPLACE SECTION
     ======================================================= */

  replaceSection(
    html,
    selector
  ) {

    if (!html) {

      return;

    }


    const existing =
      document.querySelector(
        selector
      );


    if (!existing) {

      return;

    }


    const container =
      document.createElement(
        'div'
      );


    container.innerHTML =
      html;


    const replacement =
      container.querySelector(
        selector
      );


    if (replacement) {

      existing.replaceWith(
        replacement
      );

    }

  }

}


/* =========================================================
   START
   ========================================================= */

if (
  !window.productCardQuickAddInitialized
) {

  window.productCardQuickAddInitialized =
    true;


  document.addEventListener(
    'DOMContentLoaded',
    () => {

      new ProductCardQuickAdd();

    }
  );

}


/* ==========================================================
   MOBILE QUICK ADD - TRUE FULL WIDTH BOTTOM SHEET
   ========================================================== */

(function () {

  function isMobile() {

    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;

  }


  function openMobileQuickAdd(quickAdd) {

    if (
      !quickAdd ||
      !isMobile()
    ) return;


    /*
     * Remember where the element originally lived.
     */
    if (
      !quickAdd.dataset.originalParent
    ) {

      const parent =
        quickAdd.parentElement;


      if (parent) {

        quickAdd._originalParent =
          parent;


        quickAdd._originalNextSibling =
          quickAdd.nextElementSibling;

      }

    }


    /*
     * MOVE THE SHEET DIRECTLY INTO BODY.
     */
    if (
      quickAdd.parentElement !==
      document.body
    ) {

      document.body.appendChild(
        quickAdd
      );

    }


    /*
     * Create backdrop if it doesn't exist.
     */
    let backdrop =
      document.querySelector(
        '.quick-add-mobile-backdrop'
      );


    if (!backdrop) {

      backdrop =
        document.createElement(
          'div'
        );


      backdrop.className =
        'quick-add-mobile-backdrop';


      document.body.appendChild(
        backdrop
      );


      backdrop.addEventListener(
        'click',
        function () {

          closeMobileQuickAdd(
            quickAdd
          );

        }
      );

    }


    /*
     * Make backdrop appear.
     */
    requestAnimationFrame(
      function () {

        backdrop.classList.add(
          'is-visible'
        );


        quickAdd.classList.add(
          'is-mobile-open'
        );


        quickAdd.classList.add(
          'mobile-quick-add-active'
        );


        document.body.classList.add(
          'quick-add-sheet-open'
        );

      }
    );


    quickAdd.setAttribute(
      'aria-hidden',
      'false'
    );

  }


  function closeMobileQuickAdd(quickAdd) {

    if (!quickAdd) return;


    quickAdd.classList.remove(
      'is-mobile-open'
    );


    quickAdd.classList.remove(
      'mobile-quick-add-active'
    );


    quickAdd.setAttribute(
      'aria-hidden',
      'true'
    );


    const backdrop =
      document.querySelector(
        '.quick-add-mobile-backdrop'
      );


    if (backdrop) {

      backdrop.classList.remove(
        'is-visible'
      );

    }


    document.body.classList.remove(
      'quick-add-sheet-open'
    );


    /*
     * Put the selector back into its original
     * product card after closing.
     */
    setTimeout(
      function () {

        if (
          quickAdd._originalParent &&
          quickAdd.parentElement ===
            document.body
        ) {

          if (
            quickAdd._originalNextSibling &&
            quickAdd._originalNextSibling.parentElement ===
              quickAdd._originalParent
          ) {

            quickAdd._originalParent.insertBefore(
              quickAdd,
              quickAdd._originalNextSibling
            );

          }

          else {

            quickAdd._originalParent.appendChild(
              quickAdd
            );

          }

        }

      },
      400
    );

  }


  /*
   * MOBILE + BUTTON
   */
  document.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;


      const trigger =
        event.target.closest(
          '[data-mobile-quick-add-trigger]'
        );


      if (!trigger) return;


      event.preventDefault();

      event.stopPropagation();


      const card =
        trigger.closest(
          '.card-wrapper, .card'
        );


      if (!card) return;


      const quickAdd =
        card.querySelector(
          '[data-quick-add]'
        );


      if (!quickAdd) return;


      openMobileQuickAdd(
        quickAdd
      );

    },
    true
  );


  /*
   * MOBILE CLOSE BUTTON
   */
  document.addEventListener(
    'click',
    function (event) {

      if (!isMobile()) return;


      const closeButton =
        event.target.closest(
          '[data-quick-add-close]'
        );


      if (!closeButton) return;


      event.preventDefault();

      event.stopPropagation();


      const quickAdd =
        closeButton.closest(
          '[data-quick-add]'
        );


      if (!quickAdd) return;


      closeMobileQuickAdd(
        quickAdd
      );

    },
    true
  );


  /*
   * ESC KEY
   */
  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Escape'
      ) return;


      const quickAdd =
        document.querySelector(
          'body > [data-quick-add].mobile-quick-add-active'
        );


      if (quickAdd) {

        closeMobileQuickAdd(
          quickAdd
        );

      }

    }
  );


  /*
   * CLOSE IF SCREEN IS RESIZED TO DESKTOP
   */
  window.addEventListener(
    'resize',
    function () {

      if (isMobile()) return;


      const quickAdd =
        document.querySelector(
          'body > [data-quick-add].mobile-quick-add-active'
        );


      if (quickAdd) {

        closeMobileQuickAdd(
          quickAdd
        );

      }

    }
  );

})();